import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { EventService } from './../event.service';
import { TimeCurrencyService } from './../../time-currency.service';
import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import { AppService } from '../../../app.service';
import {
  MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent,
  SidemenuSubCategory, HiddenFooter, SetAllMemberCheck
} from './../../../shared/message.event';
import { UISETTING } from './../../../shared/ui-setting';
import { UtilityFunctions } from '../../../shared/utility-functions';

@Component({
  selector: 'app-events-dashboard',
  templateUrl: './events-dashboard.component.html',
  styleUrls: ['./events-dashboard.component.css'],
  providers: [
    EventService, MessageEvent, SignInEvent, LoaderEvent,
    OpenFrameEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck,
    TimeCurrencyService
  ]
})
export class EventsDashboardComponent implements OnInit {
  // Component properties
  public appCall: any;
  private _router: Router;
  private eventsData: any[] = [];
  private bgColor: string[];
  private shouldSlide: boolean = false;
  private eventsList: any[] = [];
  private upcomingEvents: any[] = [];
  private pastEvents: any[] = [];
  private noEventsText: boolean = true;
  private popUpMessage: any;
  private popUp: any;
  private vendor: any;
  private clubName: string = '';
  private messageNoEventsAdded: string;
  private uiSetting: UISETTING;
  private height: any;
  private utilityFunctions = new UtilityFunctions();
  private scrollOptions: ISlimScrollOptions;
  private vendorTimezone: string = 'UTC';
  private vendorCountry: string = 'US';

  // Filter properties
  public showUpcoming: boolean = true;
  public showPast: boolean = false;
  public activeTab: string = 'upcoming';

  public eventService: EventService;
  public appService: AppService;
  public timeCurrencyService: TimeCurrencyService;
  public messageEvent: MessageEvent;
  public signInEvent: SignInEvent;
  public loaderEvent: LoaderEvent;
  public openFrameEvent: OpenFrameEvent;
  public sidemenuSubCategory: SidemenuSubCategory;
  public hiddenFooter: HiddenFooter;
  public setAllMemberCheck: SetAllMemberCheck;

  constructor(
    router: Router,
    eventService: EventService,
    appService: AppService,
    timeCurrencyService: TimeCurrencyService,
    messageEvent: MessageEvent,
    signInEvent: SignInEvent,
    loaderEvent: LoaderEvent,
    openFrameEvent: OpenFrameEvent,
    sidemenuSubCategory: SidemenuSubCategory,
    hiddenFooter: HiddenFooter,
    setAllMemberCheck: SetAllMemberCheck
  ) {
    this._router = router;
    this.eventService = eventService;
    this.appService = appService;
    this.timeCurrencyService = timeCurrencyService;
    this.messageEvent = messageEvent;
    this.signInEvent = signInEvent;
    this.loaderEvent = loaderEvent;
    this.openFrameEvent = openFrameEvent;
    this.sidemenuSubCategory = sidemenuSubCategory;
    this.hiddenFooter = hiddenFooter;
    this.setAllMemberCheck = setAllMemberCheck;

    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 40
    };

    this.scrollOptions = {
      barBackground: '#343a40',
      barOpacity: '0.6',
      position: 'right',
      barWidth: '6',
      barBorderRadius: '5',
      barMargin: '1px 1px',
      gridBackground: '#adb5bd',
      gridOpacity: '1',
      gridWidth: '4',
      gridBorderRadius: '10',
      gridMargin: '1px 2px'
    };

    this.height = (
      this.uiSetting.windowHeight -
      (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)
    ) + 'px';

    this.bgColor = CONSTANT_VALUES.COLOR;
    this.messageNoEventsAdded = CONSTANT_MESSAGES.MESSAGE_NO_EVENTS_ADDED;
  }

  ngOnInit(): void {
    this.emitOpenFrameEvent();
    window.scrollTo(0, 0);

    try {
      var vendorStr = localStorage.getItem('vendor');
      this.vendor = vendorStr ? JSON.parse(atob(vendorStr)) : {};
    } catch (e) {
      this.vendor = {};
    }

    this.setVendorTimezoneAndCountry();

    if (this.vendor && this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        var subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = (this.vendor && this.vendor.clubName) ? this.vendor.clubName : '';
    }

    this.getEventsByClub();

    var obj = {
      category: 'All Events',
      menu: 'Events'
    };
    this.sidemenuSubCategory.fire(obj);
    this.removePreviousEventFromLocalStorage();
    this.loaderEvent.fire(false);
    this._router.navigate(['/events']);
    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
  }

  private setVendorTimezoneAndCountry(): void {
    var country = (this.vendor && this.vendor.country) ? this.vendor.country : 'Singapore';
    var tz = (this.vendor && this.vendor.timezoneUTC) ? this.vendor.timezoneUTC : 'Asia/Singapore';

    if (this.vendor && this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        country = this.vendor.country || country;
        tz = this.vendor.timezoneUTC || tz;
      }
    }

    this.vendorCountry = country;
    this.vendorTimezone = tz;
  }

  private mapEventTimings(event: any): any {
    var mappedEvent = Object.assign({}, event, {
      startTime: (event.timings && event.timings.openTime) ? event.timings.openTime : event.time,
      endTime: (event.timings && event.timings.closeTime) ? event.timings.closeTime : null,
      cleanLocation: this.getCleanLocation(event)
    });
    return mappedEvent;
  }

  private getCleanLocation(event: any): string {
    var parts: string[] = [];

    if (event.addressLine1 && event.addressLine1.trim() !== '') parts.push(event.addressLine1);
    if (event.addressLine2 && event.addressLine2.trim() !== '') parts.push(event.addressLine2);
    if (event.addressLine3 && event.addressLine3.trim() !== '') parts.push(event.addressLine3);
    if (event.pincode && event.pincode.trim() !== '') parts.push(event.pincode);

    if (event.country && event.country.trim() !== '') {
      var countryInfo: any = this.timeCurrencyService.getTimeCurrencyInfo(event.country);
      if (countryInfo && countryInfo.country) parts.push(countryInfo.country);
    }

    return parts.join(', ');
  }

  private getEventTimezone(event: any): string {
    if (event.country && event.country.trim() !== '') {
      return this.timeCurrencyService.getTimezoneByCountry(event.country);
    }

    if (event.timezoneUTC && event.timezoneUTC.trim() !== '') {
      return event.timezoneUTC;
    }

    if (event.location && event.location.trim() !== '') {
      var countryFromLocation = this.timeCurrencyService.extractCountryFromAddress(event.location);
      if (countryFromLocation) {
        return this.timeCurrencyService.getTimezoneByCountry(countryFromLocation);
      }
    }

    return this.vendorTimezone;
  }

  private getCurrentDateInVendorTimezone(): Date {
    return new Date();
  }

  private getCurrentDateInEventTimezone(event: any): Date {
    return new Date();
  }

  private normalizeTimeTail(t?: string): string {
    if (!t) return '';
    var s = t.trim();
    var re = /^(\d{1,2}:\d{2}:\d{2}):00$/i;
    if (re.test(s)) {
      return s.slice(0, s.lastIndexOf(':'));
    }
    return s;
  }

  private isValidTimeString(timeString: string): boolean {
    if (!timeString || timeString.trim() === '') {
      return true;
    }

    var normalized = this.normalizeTimeTail(timeString);
    var upper = normalized.toUpperCase();

    var re24 = /^(?:[01]?\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/;
    var re12 = /^(?:0?[1-9]|1[0-2]):[0-5]\d(?::[0-5]\d)?\s?(AM|PM)$/i;
    return re24.test(upper) || re12.test(upper);
  }
  private isEventDateTimeValid(dateString: string, startTime?: string, endTime?: string): boolean {
    if (
      !dateString ||
      dateString.trim() === '' ||
      dateString === 'null' ||
      dateString === 'undefined' ||
      dateString === 'Invalid Date'
    ) {
      return false;
    }

    const cleanDateString = dateString.trim();
    let eventDate: Date | null = null;

    try {
      // Match ISO YYYY-MM-DD
      let match = cleanDateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        const y = parseInt(match[1], 10);
        const m = parseInt(match[2], 10);
        const d = parseInt(match[3], 10);
        eventDate = new Date(y, m - 1, d);

        // Validate rollover
        if (
          eventDate.getFullYear() !== y ||
          eventDate.getMonth() !== (m - 1) ||
          eventDate.getDate() !== d
        ) {
          return false;
        }
      }

      // Match US MM/DD/YYYY
      if (!eventDate) {
        match = cleanDateString.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (match) {
          const m = parseInt(match[1], 10);
          const d = parseInt(match[2], 10);
          const y = parseInt(match[3], 10);
          eventDate = new Date(y, m - 1, d);

          if (
            eventDate.getFullYear() !== y ||
            eventDate.getMonth() !== (m - 1) ||
            eventDate.getDate() !== d
          ) {
            return false;
          }
        }
      }

      // Fallback full ISO or other parseable formats
      if (!eventDate) {
        const tryDate = new Date(cleanDateString);
        if (isNaN(tryDate.getTime())) return false;
        eventDate = tryDate;
      }

      // Year sanity check
      const year = eventDate.getFullYear();
      if (year < 1900 || year > 2100) return false;

      // Validate times
      const startNorm = this.normalizeTimeTail(startTime || '');
      const endNorm = this.normalizeTimeTail(endTime || '');

      if (startNorm && !this.isValidTimeString(startNorm)) return false;
      if (endNorm && !this.isValidTimeString(endNorm)) return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  private parseTimeString(timeString: string): { hours: number, minutes: number, seconds: number, formatted: string } {
    let hours = 0, minutes = 0, seconds = 0;

    try {
      const normalized = this.normalizeTimeTail(timeString || "");
      const upper = normalized.toUpperCase();

      // 24-hour format HH:mm[:ss]
      let m = upper.match(/^(\d{1,2}):([0-5]\d)(?::([0-5]\d))?$/);
      if (m) {
        hours = parseInt(m[1], 10);
        minutes = parseInt(m[2], 10);
        seconds = m[3] ? parseInt(m[3], 10) : 0;
      } else {
        // 12-hour format HH:mm[:ss] AM/PM
        m = upper.match(/^(\d{1,2}):([0-5]\d)(?::([0-5]\d))?\s*(AM|PM)$/);
        if (m) {
          hours = parseInt(m[1], 10);
          minutes = parseInt(m[2], 10);
          seconds = m[3] ? parseInt(m[3], 10) : 0;
          const period = m[4];

          if (period === "PM" && hours !== 12) hours += 12;
          if (period === "AM" && hours === 12) hours = 0;
        } else {
          return { hours: 0, minutes: 0, seconds: 0, formatted: "12:00:00 AM" };
        }
      }

      // Validate ranges
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
        return { hours: 0, minutes: 0, seconds: 0, formatted: "12:00:00 AM" };
      }
    } catch (e) {
      return { hours: 0, minutes: 0, seconds: 0, formatted: "12:00:00 AM" };
    }

    // Convert to AM/PM format string
    const period = hours >= 12 ? "PM" : "AM";
    let displayHours = hours % 12;
    if (displayHours === 0) displayHours = 12;

    const formatted = `${this.pad(displayHours)}:${this.pad(minutes)}:${this.pad(seconds)} ${period}`;
    return { hours, minutes, seconds, formatted };
  }

  private pad(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }


  getTimezoneAbbreviation(): string {
    return (this.vendor && this.vendor.timezoneAbbr) ? this.vendor.timezoneAbbr : 'UTC';
  }

  getEventTimezoneAbbreviation(event: any): string {
    if (event.country && event.country.trim() !== '') {
      return this.timeCurrencyService.getTimezoneAbbreviationByCountry(event.country);
    }

    if (event.timezoneAbbr && event.timezoneAbbr.trim() !== '') {
      return event.timezoneAbbr;
    }

    if (event.location && event.location.trim() !== '') {
      var countryFromLocation = this.timeCurrencyService.extractCountryFromAddress(event.location);
      if (countryFromLocation) {
        return this.timeCurrencyService.getTimezoneAbbreviationByCountry(countryFromLocation);
      }
    }

    return (this.vendor && this.vendor.timezoneAbbr) ? this.vendor.timezoneAbbr : 'UTC';
  }

  private formatEventTimeWithEventTimezone(event: any): string {
    try {
      if (!event.startTime || !event.endTime) {
        return '';
      }

      const start = this.formatToAmPm(event.startTime);
      const end = this.formatToAmPm(event.endTime);
      const tz = this.getEventTimezoneAbbreviation(event);

      return `${start} - ${end} ${tz}`;
    } catch (e) {
      return '';
    }
  }

  private formatToAmPm(timeString: string): string {
    try {
      // Supports "HH:mm", "HH:mm:ss", "HH:mm:ss:SS"
      const parts = timeString.split(":").map(p => parseInt(p, 10));

      if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) {
        return timeString; // fallback if invalid
      }

      const h = parts[0];
      const m = parts[1];
      const s = parts.length >= 3 && !isNaN(parts[2]) ? parts[2] : undefined;

      const period = h >= 12 ? "PM" : "AM";
      let displayHours = h % 12;
      if (displayHours === 0) displayHours = 12;

      return (
        this.pad(displayHours) +
        ":" +
        this.pad(m) +
        (s !== undefined ? ":" + this.pad(s) : "") +
        " " +
        period
      );
    } catch (e) {
      return timeString;
    }
  }

  private parseEventDateTimeWithTimezone(event: any): {
    startDateTime: Date;
    endDateTime: Date;
  } {
    var baseDate = new Date(event.date);
    if (isNaN(baseDate.getTime())) {
      return {
        startDateTime: new Date(NaN),
        endDateTime: new Date(NaN)
      };
    }

    var startDateTime = new Date(baseDate);
    if ((event.startTime && event.startTime.trim() !== '') || (event.time && event.time.trim() !== '')) {
      var startSource = this.normalizeTimeTail(event.startTime ? event.startTime : event.time);
      var parsedS = this.parseTimeString(startSource);
      startDateTime.setHours(parsedS.hours, parsedS.minutes, parsedS.seconds, 0);
    } else {
      startDateTime.setHours(0, 0, 0, 0);
    }

    var endDateTime = new Date(baseDate);
    if (event.endTime && event.endTime.trim() !== '') {
      var endSource = this.normalizeTimeTail(event.endTime);
      var parsedE = this.parseTimeString(endSource);
      endDateTime.setHours(parsedE.hours, parsedE.minutes, parsedE.seconds, 999);
    } else {
      endDateTime.setHours(23, 59, 59, 999);
    }

    return { startDateTime: startDateTime, endDateTime: endDateTime };
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  private isEventCompletedWithTimezone(event: any): boolean {
    if (!this.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
      return true;
    }
    var now = this.getCurrentDateInEventTimezone(event);
    var parsed = this.parseEventDateTimeWithTimezone(event);
    if (isNaN(parsed.endDateTime.getTime())) return true;
    return now > parsed.endDateTime;
  }

  getEventLocationInfo(event: any): string {
    if (event.cleanLocation) {
      return event.cleanLocation;
    }

    var parts: string[] = [];

    if (event.location && event.location.trim() !== '') parts.push(event.location);

    if (event.country && event.country.trim() !== '' && (!event.location || event.location.indexOf(event.country) === -1)) {
      var countryInfo: any = this.timeCurrencyService.getTimeCurrencyInfo(event.country);
      if (countryInfo && countryInfo.country) parts.push(countryInfo.country);
    }

    return parts.join(', ');
  }

  getEventCurrencyInfo(event: any): any {
    if (event.country && event.country.trim() !== '') {
      return this.timeCurrencyService.getTimeCurrencyInfo(event.country);
    }

    if (event.location && event.location.trim() !== '') {
      var countryFromLocation = this.timeCurrencyService.extractCountryFromAddress(event.location);
      if (countryFromLocation) {
        return this.timeCurrencyService.getTimeCurrencyInfo(countryFromLocation);
      }
    }

    return this.timeCurrencyService.getTimeCurrencyInfo(this.vendorCountry);
  }

  getEventStatusIcon(event: any): string {
    if (!this.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
      return 'fa fa-exclamation-triangle';
    }

    var now = this.getCurrentDateInEventTimezone(event);
    var times = this.parseEventDateTimeWithTimezone(event);

    if (isNaN(times.startDateTime.getTime()) || isNaN(times.endDateTime.getTime())) {
      return 'fa fa-exclamation-triangle';
    }

    if (now < times.startDateTime) {
      return 'fa fa-clock-o';
    } else if (now >= times.startDateTime && now <= times.endDateTime) {
      return 'fa fa-play-circle';
    } else {
      return 'fa fa-check-circle';
    }
  }

  getInvalidEvents(): any[] {
    var that = this;
    return this.pastEvents.filter(function (event: any) {
      return !that.isEventDateTimeValid(event.date, event.startTime, event.endTime);
    });
  }

  getTodaysCompletedEvents(): any[] {
    var currentDateTime = this.getCurrentDateInVendorTimezone();
    var that = this;

    return this.pastEvents.filter(function (event: any) {
      if (!that.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
        return false;
      }
      var dt = that.parseEventDateTimeWithTimezone(event);
      var endDT = dt.endDateTime;
      if (isNaN(endDT.getTime())) return false;

      return that.isSameDay(endDT, currentDateTime) && endDT <= currentDateTime;
    });
  }

  registerTypeBroadcast(): void {
    var that = this;
    this.messageEvent.on().subscribe(function (message: any) {
      that.shouldSlide = message;
    });
  }

  getEventsByClub(): void {
    var vendorObj: any = { vendorId: '', showPastData:true };
    if (this.vendor && this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      vendorObj.vendorId = this.vendor._id;
    } else if (this.vendor && this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors && this.vendor.subVendors.length > 0) {
        var subVendor = this.vendor.subVendors[0];
        vendorObj.vendorId = subVendor._id;
      }
    }

    var that = this;
    this.eventService.getClubEvents(vendorObj).then(function (result: any) {
      if (result.status === 'SUCCESS') {
        that.eventsData = result.eventsData || [];
        that.noEventsText = that.eventsData.length !== 0;

        that.eventsData = that.eventsData.map(function (rec: any) {
          var count = 0;
          rec.data = (rec.data || []).map(function (eventItem: any) {
            eventItem = that.mapEventTimings(eventItem);
            var foundIcon: any = _.find(CONSTANT_VALUES.ICON_LIST_IMAGE, {
              name: eventItem.icon
            });
            eventItem.iconClass = foundIcon ? foundIcon.iconClass : 'icon-default';

            eventItem.color = that.bgColor[count];
            count++;
            if (count >= that.bgColor.length) {
              count = 0;
            }
            return eventItem;
          });
          return rec;
        });

        console.log('Raw events data:', that.eventsData);
        for (var catIndex = 0; catIndex < that.eventsData.length; catIndex++) {
          var category = that.eventsData[catIndex];
          for (var eventIndex = 0; eventIndex < (category.data || []).length; eventIndex++) {
            var event = category.data[eventIndex];
            console.log('Event ' + catIndex + '-' + eventIndex + ':', {
              name: event.name,
              date: event.date,
              originalTime: event.time,
              timings: event.timings,
              startTime: event.startTime,
              endTime: event.endTime,
              country: event.country,
              timezone: that.getEventTimezone(event),
              isValid: that.isEventDateTimeValid(event.date, event.startTime, event.endTime),
              isCompleted: that.isEventCompletedWithTimezone(event)
            });
          }
        }

        that.separateEventsByDate();

        try {
          localStorage.setItem('vendor_eventsData', JSON.stringify(that.eventsData));
        } catch (e) { }
      } else {
        that.popUp = true;
        that.popUpMessage = result.message;
      }

      that.loaderEvent.fire(true);
    }).catch(function (err: any) {
      that.popUp = true;
      that.popUpMessage = err;
      console.error('Error loading events:', err);
    });
  }

  private separateEventsByDate(): void {
    this.upcomingEvents = [];
    this.pastEvents = [];

    for (var i = 0; i < this.eventsData.length; i++) {
      var category = this.eventsData[i];
      var categoryName = category.categoryName;
      for (var j = 0; j < (category.data || []).length; j++) {
        var event = category.data[j];

        var eventWithCategory = Object.assign({}, event, {
          categoryName: categoryName
        });

        if (!this.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
          this.pastEvents.push(eventWithCategory);
          continue;
        }

        if (this.isEventCompletedWithTimezone(event)) {
          this.pastEvents.push(eventWithCategory);
        } else {
          this.upcomingEvents.push(eventWithCategory);
        }
      }
    }

    var that = this;
    this.upcomingEvents.sort(function (a: any, b: any) {
      var dateTimeA = that.parseEventDateTimeWithTimezone(a);
      var dateTimeB = that.parseEventDateTimeWithTimezone(b);
      return dateTimeA.startDateTime.getTime() - dateTimeB.startDateTime.getTime();
    });

    this.pastEvents.sort(function (a: any, b: any) {
      var dateTimeA = that.parseEventDateTimeWithTimezone(a);
      var dateTimeB = that.parseEventDateTimeWithTimezone(b);
      return dateTimeB.endDateTime.getTime() - dateTimeA.endDateTime.getTime();
    });

    console.log('Events categorized:', {
      upcoming: this.upcomingEvents.length,
      past: this.pastEvents.length
    });
  }

  switchTab(tab: string): void {
    this.activeTab = tab;
    if (tab === 'upcoming') {
      this.showUpcoming = true;
      this.showPast = false;
    } else {
      this.showUpcoming = false;
      this.showPast = true;
    }
  }

  getEventsToDisplay(): any[] {
    return this.showUpcoming ? this.upcomingEvents : this.pastEvents;
  }

  openAddEventForm(): void {
    this._router.navigate(['/addevent']);
  }

  openBroadcastEventForm(): void {
    this._router.navigate(['/event-broadcast']);
  }

  viewEvent(eventData: any, eventArray: any): void {
    var count = 0;
    this.eventsList = [];
    var arr = eventArray && eventArray.data ? eventArray.data : [];
    for (var i = 0; i < arr.length; i++) {
      var event = arr[i];
      this.eventsList[count] = event.name;
      count++;
    }

    try {
      localStorage.setItem('eventsList', JSON.stringify(this.eventsList));
    } catch (e) { }
    this.appService.storeFacility(eventData);
    this._router.navigate(['/addevent']);
  }

  formatEventDate(dateString: string): string {
    if (!dateString || this.isEventDateTimeValid(dateString) === false) {
      return 'Invalid Date';
    }

    var s = dateString.trim();

    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      var d = new Date(Number(m[1]), Number(m) - 1, Number(m));
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString('en-US', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
      return 'Invalid Date';
    }

    m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (m) {
      var d2 = new Date(Number(m[3]), Number(m) - 1, Number(m));
      if (!isNaN(d2.getTime())) {
        return d2.toLocaleDateString('en-US', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
      return 'Invalid Date';
    }

    var d3 = new Date(s);
    if (!isNaN(d3.getTime())) {
      return d3.toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }

    return 'Invalid Date';
  }

  getEventStatusClass(event: any): string {
    if (!this.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
      return 'badge-warning';
    }

    var now = this.getCurrentDateInEventTimezone(event);
    var times = this.parseEventDateTimeWithTimezone(event);

    if (isNaN(times.startDateTime.getTime()) || isNaN(times.endDateTime.getTime())) {
      return 'badge-warning';
    }

    if (now < times.startDateTime) {
      return 'badge-success';
    } else if (now >= times.startDateTime && now <= times.endDateTime) {
      return 'badge-info';
    } else {
      return 'badge-secondary';
    }
  }

  getEventStatusText(event: any): string {
    if (!this.isEventDateTimeValid(event.date, event.startTime, event.endTime)) {
      return 'Invalid Date/Time';
    }

    var now = this.getCurrentDateInEventTimezone(event);
    var times = this.parseEventDateTimeWithTimezone(event);

    if (isNaN(times.startDateTime.getTime()) || isNaN(times.endDateTime.getTime())) {
      return 'Invalid Date/Time';
    }

    if (now < times.startDateTime) {
      if (this.isSameDay(times.startDateTime, now)) {
        return 'Later Today';
      }
      return 'Upcoming';
    } else if (now >= times.startDateTime && now <= times.endDateTime) {
      return 'In Progress';
    } else {
      return 'Completed';
    }
  }

  emitTypeBroadcast(): void {
    var isShow: any = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitTypeLoaderBroadcast(): void {
    this.loaderEvent.fire(false);
  }

  emitOpenFrameEvent(): void {
    this.openFrameEvent.fire(false);
  }

  homeScreen(): void {
    this.utilityFunctions.homeScreen(this);
  }

  removePreviousEventFromLocalStorage(): void {
    if (localStorage.getItem('facility')) {
      localStorage.removeItem('facility');
    }
    if (localStorage.getItem('currentCategory')) {
      localStorage.removeItem('currentCategory');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/facility/event/events-dashboard/events-dashboard.component.ts